import {
    GET_PLUS_HAS_SEEN_DESCRIPTION,
    GET_PLUS_HAS_SEEN_HEADLINE,
    GET_PLUS_HEADING_TITLE,
    GET_PLUS_NO_ADS_DESCRIPTION,
    GET_PLUS_NO_ADS_HEADLINE,
    GET_PLUS_PRICING,
    GET_PLUS_REDUCED_DESCRIPTION,
    GET_PLUS_REDUCED_HEADLINE,
    GET_PLUS_TITLE_CALL_TO_ACTION,
    GET_PLUS_TOPPED_DESCRIPTION,
    GET_PLUS_TOPPED_FOOTNOTE,
    GET_PLUS_TOPPED_HEADLINE,
    GET_PLUS_WHAT_I_HAVE_GOT,
    GET_PLUS_WHAT_YOU_GET,
    GET_PRO_COMPARE_PLANS_FREE_plus_pro,
    GET_PRO_NEED_HELP_faq,
    GET_PRO_NEED_HELP_PAID_PLANS,
} from 'mk/autogenerated/translations/GetPlus.fddb4bd96ba9ee35681931405ccd6eee'
import { isAnonymousUser } from 'mk/bazaar/common/userUtils';
import assetUrl from 'mk/common/assetUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { faqPlanPlusProUrl } from 'mk2/apps/faq/urls';
import LineSeparator from 'mk2/apps/plan/components/LineSeparator';
import PlanPanel from 'mk2/apps/plan/components/PlanPanel';
import { PriceList } from 'mk2/apps/plan/components/PriceList';
import { Props } from 'mk2/apps/plan/containers/GetPlus/GetPlusPage';
import { planChoosePlanUrl, planGetPlusUrl } from 'mk2/apps/plan/urls';
import { AvatarImg } from 'mk2/components/AvatarImg';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Img } from 'mk2/components/Img';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import { Panel } from 'mk2/components/Panel';
import { PlusBadge } from 'mk2/components/PlusBadge';
import { ProBadge } from 'mk2/components/ProBadge';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { removeEmpty, url } from 'mk2/helpers/urls';
import { isLoading } from 'mk2/reducers/loadingState';
import { parse } from 'query-string';
import React from 'react';
import styles from './GetPlus.mscss';

export default class GetPlus extends React.Component<Props> {

    public componentDidMount() {
        const { location, onLoad, requestUser, bazaarPlusId } = this.props;
        if (isAnonymousUser(requestUser) !== !bazaarPlusId) {
            const qs = removeEmpty(parse(location.search) || {});
            onLoad(qs.src as string);
        }
    }

    public render() {
        const { loadingState, plusPrices } = this.props;
        return (
            <div className={styles.GetPlus}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onRenderInit={this.renderInitOrSuccess}
                    onRenderSuccess={this.renderInitOrSuccess}
                    onLoad={this.load}
                    hasData={!!plusPrices}
                />
            </div>
        );
    }

    private load = () => {
        const { location, onLoad } = this.props;
        const qs = removeEmpty(parse(location.search) || {});
        onLoad(qs.src as string);
    };

    private renderInitOrSuccess = () => {
        const {
            allowPayments, avatars, isMobile, loadingState, bazaarPlusId, onStoreEvent, paymentVS,
            planIsActiveAndDisplaying, plusPrices, requestUser, location,
        } = this.props;

        const countryCode = {201: 'sk', 202: 'cz'}[ACTIVE_SERVER_ID];
        return (
            <>
                {(!bazaarPlusId || !planIsActiveAndDisplaying) && (
                    <Panel className={styles.GetPlus__mainPanel}>
                        <div className={styles.GetPlus__avatar}>
                            <AvatarImg
                                user={requestUser}
                                size={isMobile ? 110 : 124}
                                className={styles.GetPlus__avatar__me}
                                forceShowPlanBadge={'plus'}
                            />
                            <div className={styles.GetPlus__avatar__others}>
                                {isLoading(loadingState) ? (
                                    <>
                                        {Array.from(Array(42).keys()).map((idx) => (
                                            <LoadingPlaceholder
                                                key={idx}
                                                width={50}
                                                height={50}
                                                className={styles.GetPlus__avatar__others__other}
                                            />
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        {avatars.map((avatar, idx) => (
                                            <AvatarImg
                                                key={idx}
                                                size={50}
                                                user={avatar}
                                                href={url(blogsProfileUrl, { username: avatar.username })}
                                                className={styles.GetPlus__avatar__others__other}
                                            />
                                        ))}
                                    </>
                                )}
                            </div>
                        </div>
                        <h2 className={styles.GetPlus__title}>
                            {GET_PLUS_HEADING_TITLE}
                            &nbsp;
                            <PlusBadge />
                        </h2>
                        <Btn
                            link={url(planGetPlusUrl, {}, {}, 'pricelist')}
                            type={BtnType.BzGreen}
                            label={GET_PLUS_TITLE_CALL_TO_ACTION}
                        />
                    </Panel>
                )}

                <LineSeparator
                    title={bazaarPlusId && planIsActiveAndDisplaying
                        ? GET_PLUS_WHAT_I_HAVE_GOT.replace(/<span.*>.*<\/span>/, '')
                        : GET_PLUS_WHAT_YOU_GET}
                />

                <PlanPanel
                    headline={GET_PLUS_TOPPED_HEADLINE}
                    description={GET_PLUS_TOPPED_DESCRIPTION}
                    image={(
                        <Img
                            width={586}
                            height={136}
                            className={styles.GetPlus__screenshot}
                            src={assetUrl + `img/bazaar/get_plus_topped-${countryCode}.png`}
                        />
                    )}
                    imageFootnote={GET_PLUS_TOPPED_FOOTNOTE}
                />

                <PlanPanel
                    headline={GET_PLUS_REDUCED_HEADLINE}
                    description={GET_PLUS_REDUCED_DESCRIPTION}
                    image={(
                        <Img
                            width={586}
                            height={136}
                            className={styles.GetPlus__screenshot}
                            src={assetUrl + `img/bazaar/get_plus_reduced-${countryCode}.png`}
                        />
                    )}
                />

                <PlanPanel
                    headline={GET_PLUS_HAS_SEEN_HEADLINE}
                    description={GET_PLUS_HAS_SEEN_DESCRIPTION}
                    image={(
                        <Img
                            width={586}
                            height={136}
                            className={styles.GetPlus__screenshot}
                            src={assetUrl + `img/bazaar/get_plus_seen-${countryCode}.png`}
                        />
                    )}
                />

                <PlanPanel
                    headline={GET_PLUS_NO_ADS_HEADLINE}
                    description={GET_PLUS_NO_ADS_DESCRIPTION}
                />

                <div className={styles.GetPlus__linkWrapper}>
                    <Link
                        to={planChoosePlanUrl}
                    >
                        <Interpolate
                            i18nKey={GET_PRO_COMPARE_PLANS_FREE_plus_pro}
                            plus={<PlusBadge />}
                            pro={<ProBadge />}
                        />
                    </Link>
                </div>

                <div className={styles.GetPlus__linkWrapper}>
                    <Interpolate
                        i18nKey={GET_PRO_NEED_HELP_faq}
                        faq={(
                            <Link to={faqPlanPlusProUrl}>{GET_PRO_NEED_HELP_PAID_PLANS}</Link>
                        )}
                    />
                </div>

                <LineSeparator title={GET_PLUS_PRICING} />

                <div id="pricelist">
                    <PriceList
                        allowPayments={allowPayments}
                        bazaarPlusId={bazaarPlusId}
                        bazaarProId={null}
                        onStoreEvent={onStoreEvent}
                        paymentVS={paymentVS}
                        priceListOf={'plus'}
                        prices={plusPrices}
                        requestUser={requestUser}
                    />
                </div>
            </>
        );
    };
}
